let navMenuDictionary = [{
    menuName: "项目管理",
    pageUrl: "projectList",
    iconPath: require("../assets/icon/projectManage.png"),
    iconInfo: {
        className: "ic-ico_folder1",
        size: "12px",
        color: "linear-gradient(323deg, var(--base-bg-light-color19) 0%, var(--base-bg-light-color20) 100%)"
    },
    isCheck: true,
    permissionCode: "",
}, {
    menuName: "数据统计",
    pageUrl: "dataStatistics",
    iconPath: require("../assets/icon/dataStatistics.png"),
    iconInfo: {
        className: "icon-a-xingzhuang15",
        size: "12px",
        color: "var(--base-bg-light-color39)"
    },
    isCheck: true,
}, {
    menuName: "API调用",
    pageUrl: "apiUsage",
    iconPath: require("../assets/icon/dataStatistics.png"),
    isCheck: true,
    permissionCode: "Statistics.AuditApi"
}, {
    menuName: "异常统计",
    pageUrl: "exceptionStatistics",
    iconPath: require("../assets/icon/dataStatistics.png"),
    isCheck: true,
    permissionCode: "Statistics.Exception"
}, {
    menuName: "下载统计",
    pageUrl: "downloadStatistics",
    iconPath: require("../assets/icon/dataStatistics.png"),
    isCheck: true,
    permissionCode: "Statistics.Download"
}, {
    menuName: "分享管理",
    pageUrl: "shareManage",
    iconPath: require("../assets/icon/shareManage.png"),
    iconInfo: {
        className: "icon-fenxiangguanli",
        size: "12px",
        color: "var(--base-bg-light-color32)"
    },
    isCheck: true,
    permissionCode: ""
}, {
    menuName: "我的分享",
    pageUrl: "myShare",
    isCheck: true,
    permissionCode: "Project.Share.List"
}, {
    menuName: "他人分享",
    pageUrl: "othersShare",
    isCheck: true,
    permissionCode: "Project.Share.ShareToMe.List"
}, {
    menuName: "构件库管理",
    pageUrl: "elementManage",
    iconPath: require("../assets/icon/elementManage.png"),
    iconInfo: {
        className: "icon-goujiankuguanli",
        size: "12px",
        color: "var(--base-bg-light-color39)"
    },
    isCheck: true,
    permissionCode: "",
}, {
    menuName: "公共构件",
    pageUrl: "publicElement",
    isCheck: true,
    permissionCode: "Project.ComponentLibrary.Public",
}, {
    menuName: "我的构件",
    pageUrl: "privateElement",
    isCheck: true,
    permissionCode: "Project.ComponentLibrary.Private",
}, {
    menuName: "系统管理",
    pageUrl: "systemManage",
    iconPath: require("../assets/icon/systemManage.png"),
    iconInfo: {
        className: "icon-xitongguanli",
        size: "12px",
        color: "var(--base-bg-light-color37)"
    },
    isCheck: true,
    permissionCode: "",
}, {
    menuName: "用户管理",
    pageUrl: "userManage",
    isCheck: true,
    permissionCode: "User.Query",
}, {
    menuName: "角色管理",
    pageUrl: "roleManage",
    isCheck: true,
    permissionCode: "Role.Query",
}, {
    menuName: "权限管理",
    pageUrl: "permissionManage",
    isCheck: true,
    permissionCode: "Permission.Query",
}, {
    menuName: "团队管理",
    pageUrl: "teamManage",
    isCheck: true,
    permissionCode: "TeamManage",
}, {
    menuName: "项目成员管理",
    pageUrl: "projMemberManage",
    isCheck: true,
    permissionCode: "Project.ManagerManage",
}, {
    menuName: "服务器配置",
    pageUrl: "serviceConfig",
    isCheck: true,
    permissionCode: "Server.GetGlobalConfig",
},
{
    menuName: "SAAS服务权限配置",
    pageUrl: "sassConfig",
    isCheck: true,
    permissionCode: "Server.SysInitialize.View",
},
{
    menuName: "私有化部署权限配置",
    pageUrl: "privateConfig",
    isCheck: true,
    permissionCode: "Server.PrivateSysInitialize.View",
}, {
    menuName: "数据迁移",
    pageUrl: "dataMigration",
    iconPath: require("../assets/icon/dataMigration.png"),
    iconInfo: {
        className: "icon-shujuqianyi",
        size: "12px",
        color: "var(--base-bg-light-color37)"
    },
    isCheck: true,
    permissionCode: "Data.Migration",
}, {
    menuName: "离线数据包",
    pageUrl: "offlineDataZip",
    iconPath: require("../assets/icon/offlinePackage.png"),
    isCheck: true,
    iconInfo: {
        className: "icon-lixianshujubao",
        size: "12px",
        color: "var(--base-bg-light-color32)"
    },
    permissionCode: "Project.OfflinePackageManage",
}]

let singleBackPaths = [
    {
        menu: "panoramicDisplay",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "dataManage",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "sceneList",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "sharedSceneList",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "myShare",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "projectSummary",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "basicInfo",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "projManager",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "dataDictionary",
        backPath: "/projectList?projectType=single",
        isBackToHome: true,
    },
    {
        menu: "datasetView",
        backPath: "/singleProject/dataManage",
        isBackToHome: false,
    },
    {
        menu: "versionCompare",
        backPath: "/singleProject/dataManage",
        isBackToHome: false,
    },
    {
        menu: "sceneView",
        backPath: "/singleProject/sceneList",
        isBackToHome: false,
    },
    {
        menu: "sceneEdit",
        backPath: "/singleProject/sceneList",
        isBackToHome: false,
    },
];

let dataTypeList = [{
    id: 'Bim',
    permissionCode: 'Project.Single.DataSet.Bim'
}, {
    id: 'Rs',
    permissionCode: 'Project.Single.DataSet.Rs'
}, {
    id: 'Wmts',
    permissionCode: 'Project.Single.DataSet.Wmts'
}, {
    id: 'Osgb',
    permissionCode: 'Project.Single.DataSet.Osgb'
}, {
    id: 'Panorama',
    permissionCode: 'Project.Single.DataSet.Panorama'
}, {
    id: 'PointCloud',
    permissionCode: 'Project.Single.DataSet.PointCloud'
}, {
    id: 'Cad',
    permissionCode: 'Project.Single.DataSet.CadTree'
}, {
    id: 'Vector',
    permissionCode: 'Project.Single.DataSet.CadTree'
}]

let bimButtons = [
    {
        name: 'upload', permissionCode: 'Project.Single.Metadata.Bim.Upload',
        formatType: {
            '1': [1, 3],
            '2': [2]
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.BimTree.AddCatalog',
        formatType: {
            '1': [1, 3],
            '2': [1, 3]
        }
    },
    {
        name: 'newModelGroup', permissionCode: 'Project.Single.DataSet.BimTree.AddLeaf', formatType: {
            '1': [],
            '2': [1, 3]
        }
    },
    {
        name: 'modelView', permissionCode: 'Project.Single.Metadata.Bim.Preview', formatType: {
            '1': [],
            '2': [2]
        }
    },
    {
        name: 'submitConvert', permissionCode: 'Project.Single.Metadata.Bim.Convert',
        formatType: {
            '1': [],
            '2': [2]
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [1, 3],
            '2': []
        },
        children: [
            { name: 'setCoordinate', permissionCode: 'Project.Single.DataSet.BimTree.RenameNode' },
            { name: 'submitConvert', permissionCode: 'Project.Single.Metadata.Bim.Convert' },
            { name: 'download', permissionCode: 'Project.Single.Metadata.Bim.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Bim.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.BimTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.Bim.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.BimTree.DeleteNode' },
        ]
    },
    {
        name: 'modelGroupBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [],
            '2': [1, 3]
        },
        children: [
            { name: 'setCoordinate', permissionCode: 'Project.Single.DataSet.BimTree.RenameNode' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Bim.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.BimTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.Bim.copyTo'},
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.BimTree.DeleteNode' },
        ]
    },
    {
        name: 'filesBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [],
            '2': [2]
        },
        children: [
            { name: 'download', permissionCode: 'Project.Single.Metadata.Bim.Download' },
            { name: 'delete', permissionCode: 'Project.Single.Metadata.Bim.Delete' },
        ]
    },
]

let rsButtons = [
    {
        name: 'upload', permissionCode: 'Project.Single.Metadata.Rs.Upload',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.RsTree.AddCatalog',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'download', permissionCode: 'Project.Single.Metadata.Rs.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Rs.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.RsTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.Rs.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.RsTree.DeleteNode' },
        ]
    },
]

let wmtsButtons = [
    {
        name: 'newMap', permissionCode: 'Project.Single.DataSet.WmtsTree.AddLeaf',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.WmtsTree.AddCatalog',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'share', permissionCode: 'Project.Single.DataSet.Wmts.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.WmtsTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.WmtsTree.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.WmtsTree.DeleteNode' },
        ]
    },
]

let osgbButtons = [
    {
        name: 'upload', permissionCode: 'Project.Single.Metadata.Osgb.Upload',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.OsgbTree.AddCatalog',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'setCoordinate', permissionCode: 'Project.Single.DataSet.OsgbTree.SetCoordinates' },
            { name: 'download', permissionCode: 'Project.Single.Metadata.Osgb.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Osgb.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.OsgbTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.Osgb.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.OsgbTree.DeleteNode' },
        ]
    },
]

let panoramaButtons = [
    {
        name: 'upload', permissionCode: 'Project.Single.Metadata.Panorama.Upload',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.PanoramaTree.AddCatalog',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'submitConvert', permissionCode: 'Project.Single.Metadata.Panorama.Convert' },
            { name: 'download', permissionCode: 'Project.Single.Metadata.Panorama.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Panorama.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.PanoramaTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.PanoramaTree.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.PanoramaTree.DeleteNode' },
        ]
    },
]

let pointCloudButtons = [
    {
        name: 'upload', permissionCode: 'Project.Single.Metadata.PointCloud.Upload',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.PointCloudTree.AddCatalog',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'setCoordinate', permissionCode: 'Project.Single.DataSet.PointCloudTree.RenameNode' },
            { name: 'submitConvert', permissionCode: 'Project.Single.Metadata.PointCloud.Convert' },
            { name: 'download', permissionCode: 'Project.Single.Metadata.PointCloud.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.PointCloud.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.PointCloudTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.PointCloudTree.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.PointCloudTree.DeleteNode' },
        ]
    },
]

let cadButtons = [
    {
        name: 'upload', permissionCode: 'Project.Single.Metadata.Cad.Upload',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder', permissionCode: 'Project.Single.DataSet.CadTree.AddCatalog',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'submitConvert', permissionCode: 'Project.Single.Metadata.Cad.Convert' },
            { name: 'download', permissionCode: 'Project.Single.Metadata.Cad.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Cad.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.CadTree.MoveNode' },
            // { name: 'copyTo', permissionCode: 'Project.Single.Metadata.Cad.copyTo' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.CadTree.DeleteNode' },
        ]
    },
]

let vectorButtons = [
    {
        name: 'upload',
        permissionCode: 'Project.Single.Metadata.Vector.Upload',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'newFolder',
        permissionCode: 'Project.Single.DataSet.VectorTree.AddLeaf',
        formatType: {
            '1': [0, 1],
            '2': []
        }
    },
    {
        name: 'modelBatchOperate',
        permissionCode: '',
        formatType: {
            '1': [0, 1],
            '2': []
        },
        children: [
            { name: 'submitConvert', permissionCode: 'Project.Single.Metadata.Vector.Convert' },
            { name: 'download', permissionCode: 'Project.Single.Metadata.Vector.Download' },
            { name: 'share', permissionCode: 'Project.Single.DataSet.Vector.Share' },
            { name: 'moveTo', permissionCode: 'Project.Single.DataSet.VectorTree.MoveNode' },
            { name: 'deleteNode', permissionCode: 'Project.Single.DataSet.VectorTree.DeleteNode' },
        ]
    },
]



export {
    navMenuDictionary,
    singleBackPaths,
    dataTypeList,
    bimButtons,
    rsButtons,
    wmtsButtons,
    osgbButtons,
    panoramaButtons,
    pointCloudButtons,
    cadButtons,
    vectorButtons
};